{
  "13afb094-84f9-739f-44fd-78d036adb028": "https://wix.to/jPWO9GZ",
  "bda15dc1-816d-4ff3-8dcb-1172d5343cce": "https://wix.to/sfoURR8",
  "14fd5970-8072-c276-1246-058b79e70c1a": "https://wix.to/FPbvzSu",
  "6a25b678-53ec-4b37-a190-65fcd1ca1a63": "https://wix.to/VBf3XkQ",
  "13a94f09-2766-3c40-4a32-8edb5acdd8bc": "https://wix.to/awqi86g",
  "a91a0543-d4bd-4e6b-b315-9410aa27bcde": "https://wix.to/BaNrGoT",
  "14d2abc2-5350-6322-487d-8c16ff833c8a": "https://wix.to/GHJRTYr"
}
